import type { BrowserAnalytics } from '@transcend-io/segment/browser';
import type {
  TrackingEvent,
  TrackingEventProperties,
} from '@transcend-io/segment/core';

import { runWhenIdle } from '#/lib/run-when-idle';

/**
 * Fire a Segment track after idle so it doesn't inflate INP.
 * Use for interaction-adjacent / engagement events (link clicks, scroll).
 * Prefer `analytics.track` directly for conversions and form submits.
 */
export function trackDeferred<T extends TrackingEvent>(
  analytics: BrowserAnalytics,
  event: T,
  properties?: TrackingEventProperties[T],
): () => void {
  return runWhenIdle(() => {
    void analytics.track(event, properties);
  });
}
